import { useTheme } from '@mui/material';
import useMeasuredWidth from '../../../../../hooks/useMeasuredWidth';
import {
  BRAND_TILE_GAP,
  BRAND_TILE_WIDTH,
  computeVisibleSlots,
  selectVisibleBrands,
} from '../storeConnections.utils';
import { useStoreRecentBrands } from './useStoreRecentBrands';

export const useStoreConnectionsRow = () => {
  const theme = useTheme();
  const { brands, totalCount, isLoading } = useStoreRecentBrands();
  const { containerRef, width } = useMeasuredWidth();

  const slots = computeVisibleSlots({
    availableWidth: width,
    tileWidth: BRAND_TILE_WIDTH,
    gap: Number.parseFloat(theme.spacing(BRAND_TILE_GAP)),
  });

  const { visibleBrands, hasTrailer } = selectVisibleBrands({ brands, totalCount, slots });

  return {
    containerRef,
    slots,
    visibleBrands,
    hasTrailer,
    isLoading,
    isEmpty: totalCount === 0,
  };
};
